import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum TraineeTypeSelectionStep {
  Page = 'Page',
}

export const traineeTypeSelectionFlow: CheckinWorkflow<TraineeTypeSelectionStep> = {
  id: FlowId.TraineeTypeSelection,
  entry: TraineeTypeSelectionStep.Page,
  steps: {
    [TraineeTypeSelectionStep.Page]: {
      id: TraineeTypeSelectionStep.Page,
      page: PageKey.TRAINEE_TYPE,
      next: () => ({ complete: true }),
    },
  },
};
